// Home screen
export const FETCH_BANNERS_PICTURE = 'FETCH_BANNERS_PICTURE'
export const FETCH_LATE_NIGHTE_HOME = 'FETCH_LATE_NIGHTE_HOME'
export const FETCH_LATEST_BLOG = 'FETCH_LATEST_BLOG'
export const FETCH_BEST_RANKS = 'FETCH_BEST_RANKS'
export const FETCH_AROUND = 'FETCH_AROUND'
export const FETCH_HERO = 'FETCH_HERO'
export const FETCH_PICTURES = 'FETCH_PICTURES'
export const FETCH_SHOMAL = 'FETCH_SHOMAL'
export const FETCH_JONOOB = 'FETCH_JONOOB'
export const FETCH_THRAN_CITY = 'FETCH_THRAN_CITY'
export const FETCH_BOOMGARDI = 'FETCH_BOOMGARDI'
export const FETCH_SELECTED_CATEGORIES = 'FETCH_SELECTED_CATEGORIES'
// Search screen
export const FETCH_SEARCH_ITEMS = 'FETCH_HOUSES_ITEMS'
export const FETCH_FIRST_BOOKING_ITEMS = 'FETCH_FIRST_BOOKING_ITEMS'
export const FETCH_STATISTICS = 'FETCH_STATISTICS'
export const SET_FILTERS = 'SET_FILTERS'
export const FETCH_PLACE_ITEMS = 'FETCH_PLACE_ITEMS'
export const FETCH_FIRST_SEARCH_ITEMS = 'FETCH_FIRST_SEARCH_ITEMS'
export const FETCH_NEIGHBOURHOODS = 'FETCH_NEIGHBOURHOODS'

// Authentication
// ================================================
export const GET_TOKEN = 'GET_TOKEN'
export const GET_COUNTRIES = 'GET_COUNTRIES'
export const GET_BOOTSTRAP_DATA = 'GET_BOOTSTRAP_DATA'

// ================================================

// General Info
export const FETCH_CALENDAR = 'FETCH_CALENDAR'
export const FETCH_SEARCH_CALENDAR = 'FETCH_SEARCH_CALENDAR'
export const SET_ROUTER_LOADING = 'SET_ROUTER_LOADING'
export const SET_ENV = 'SET_ENV'
export const SUBMIT_PAYMENT = 'SUBMIT_PAYMENT'
export const SELECT_PGW = 'SELECT_PGW'

// Product Page
export const FETCH_REVIEWS = 'FETCH_REVIEWS'
export const FETCH_RESERVED_HOUSES = 'FETCH_RESERVED_HOUSES'
export const FETCH_PRODUCT_SUMMARY_REVIEWS = 'FETCH_PRODUCT_SUMMARY_REVIEWS'
export const FETCH_PRODUCT_REVIEWS_LIST = 'FETCH_PRODUCT_REVIEWS_LIST'

// Product Screen:
export const FETCH_PRODUCT = 'FETCH_PRODUCT'
export const FETCH_SIMILAR = 'FETCH_SIMILAR'
export const FETCH_WEATHER = 'FETCH_WEATHER'
export const FETCH_PROFORMA = 'FETCH_PROFORMA'
export const FETCH_PRODUCT_PICTURES = 'FETCH_PRODUCT_PICTURES'
export const SET_RESERVE = 'SET_RESERVE'
export const SET_BASIC_FILTERS = 'SET_BASIC_FILTERS'
export const VIOLATION_REPORT = 'VIOLATION_REPORT'
export const SET_REQUEST = 'SET_REQUEST'
export const GET_CANCELLATION_RULES = 'GET_CANCELLATION_RULES'

// host info:
export const FETCH_USER = 'FETCH_USER'

// Top Banner
export const GET_TOP_BANNER = 'GET_TOP_BANNER'

// Tracker url
export const GET_TRACKER_URL = 'GET_TRACKER_URL'

// NPS
export const FETCH_NPS = 'FETCH_NPS'
export const SUBMIT_NPS = 'SUBMIT_NPS'

// referral
export const FETCH_INVITATION_CODE = 'FETCH_INVITATION_CODE'
export const INVITATION_BY_SMS = 'INVITATION_BY_SMS'
export const FETCH_INVITED_LIST = 'FETCH_INVITED_LIST'
export const SETTLEMENT = 'SETTLEMENT'
export const FETCH_TOTAL_GIFT = 'FETCH_TOTAL_GIFT'
export const REMINDER = 'REMINDER'

// user
export const FETCH_USER_INFO = 'FETCH_USER_INFO'
export const EDIT_USER_INFO = 'EDIT_USER_INFO'
export const FETCH_REGION = 'FETCH_REGION'
export const FETCH_DISCOUNT_LIST = 'FETCH_DISCOUNT_LIST'
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const UPDATE_BANK_ACCOUNT = 'UPDATE_BANK_ACCOUNT'
export const FETCH_USER_REVIEWS = 'FETCH_USER_REVIEWS'
export const FETCH_REVIEWS_ABOUT_USER = 'FETCH_REVIEWS_ABOUT_USER'
export const UPLOAD_PHOTO = 'UPLOAD_PHOTO'

// reviews guest<=>host
export const FETCH_REVIEW_INFO = 'FETCH_REVIEW_INFO'
//     INVOICE
export const FETCH_INVOICE_DATA = 'FETCH_INVOICE_DATA'
export const FETCH_COMPANION_LIST = 'FETCH_COMPANION_LIST'
export const FETCH_ALL_COMPANION_LIST = 'FETCH_ALL_COMPANION_LIST'
export const ADD_COMPANION = 'ADD_COMPANION'
export const DELETE_COMPANION = 'DELETE_COMPANION'
export const UPDATE_COMPANION = 'UPDATE_COMPANION'
export const SUBMIT_DISCOUNT = 'SUBMIT_DISCOUNT'
export const FETCH_GETWAYS_LIST = 'FETCH_GETWAYS_LIST'
export const PRINT_INVOICE = 'PRINT_INVOICE'
export const USE_WALLET = 'USE_WALLET'
export const USE_PRIZE_WALLET = 'USE_PRIZE_WALLET'
export const EXPIRED_TIME = 'EXPIRED_TIME'
export const SELECT_PAYMENT_METHOD = 'SELECT_PAYMENT_METHOD'
export const SELECT_PAYMENT_METHOD_GETWAYS = 'SELECT_PAYMENT_METHOD_GETWAYS'
export const SELECT_INSTALLMENT_PAYMENT_METHOD_GETWAYS =
  'SELECT_INSTALLMENT_PAYMENT_METHOD_GETWAYS'
export const SELECT_PAYMENT_WAY = 'SELECT_PAYMENT_WAY'
export const FETCH_EDIT_RESERVE_PROFORMA = 'FETCH_EDIT_RESERVE_PROFORMA'
export const SNAPP_PAY_ELIGIBLE = 'SNAPP_PAY_ELIGIBLE'
export const CROUSE_ELIGIBLE = 'CROUSE_ELIGIBLE'
export const DIGI_PAY_ELIGIBLE = 'DIGI_PAY_ELIGIBLE'
export const EWANO_ELIGIBLE = 'EWANO_ELIGIBLE'
export const ZEECARD_ELIGIBLE = 'ZEECART_ELIGIBLE'
export const DIGI_PAY_WALLET_ELIGIBLE = 'DIGI_PAY_WALLET_ELIGIBLE'
export const GET_CANCELLING_RULE = 'GET_CANCELLING_RULE'
export const UPDATE_INVOICE_DATA = 'UPDATE_INVOICE_DATA'
export const ADD_DISCOUNT = 'ADD_DISCOUNT'

// push notification
export const GET_PUSH_NOTIFICATION = 'GET_PUSH_NOTIFICATION'

// reviewsList
export const FETCH_REVIEWS_LIST = 'FETCH_REVIEWS_LIST'
export const CHANGE_RESERVE_STATUS = 'CHANGE_RESERVE_STATUS'
export const UPDATE_RESERVE_STATUS = 'UPDATE_RESERVE_STATUS'

export const REMOVE_DISCOUNT = 'REMOVE_DISCOUNT'

// photography
export const FETCH_PHOTOGRAPHY_COST = 'FETCH_PHOTOGRAPHY_COST'
export const FETCH_HOUSE_LIST = 'FETCH_HOUSE_LIST'
export const PAYMENT_PHOTOGRAPHY = 'PAYMENT_PHOTOGRAPHY'

// bookmark
export const SET_BOOKMARK = 'SET_BOOKMARK'
export const FETCH_BOOKMARKS_LIST = 'FETCH_BOOKMARKS_LIST'
export const REMOVE_BOOKMARK = 'REMOVE_BOOKMARK'
export const GET_DEFAULT_BOOKMARK = 'GET_DEFAULT_BOOKMARK'

// hosts panel
export const FETCH_HOSTS_REVIEWS = 'FETCH_HOSTS_REVIEWS'
export const FETCH_OVERALL_STATISTICS = 'FETCH_OVERALL_STATISTICS'
export const FETCH_PENDED_RESERVES = 'FETCH_PENDED_RESERVES'
export const REMOVE_RESERVE_ITEM = 'REMOVE_RESERVE_ITEM'
export const FETCH_UNANSERWED_REVIEWS = 'FETCH_UNANSERWED_REVIEWS'
export const FETCH_DELIVERY_KEYS = 'FETCH_DELIVERY_KEYS'
export const CHANGE_PAID_WAITING_COUNT = 'CHANGE_PAID_WAITING_COUNT'
export const FETCH_GUEST_REVIEW_DETAIL = 'FETCH_GUEST_REVIEW_DETAIL'
export const FETCH_HOST_REVIEW = 'FETCH_HOST_REVIEW'
export const FETCH_RESERVATION_INFO = 'FETCH_RESERVATION_INFO'
export const FETCH_MY_HOUSES = 'FETCH_MY_HOUSES'
export const FETCH_HOST_CALENDAR_DATA = 'FETCH_HOST_CALENDAR_DATA'
export const SET_NORMAL_DISCOUNT = 'SET_NORMAL_DISCOUNT'
export const REMOVE_NORMAL_DISCOUNT = 'REMOVE_NORMAL_DISCOUNT'
export const FETCH_RESERVATIONS = 'FETCH_RESERVATIONS'
export const CHANGE_RESERVATIONS_STATUS = 'CHANGE_RESERVATIONS_STATUS'
export const FETCH_HOST_HOUSES_STATISTICS = 'FETCH_HOST_HOUSES_STATISTICS'
export const FETCH_HOST_CHART_STATISTICS = 'FETCH_HOST_CHART_STATISTICS'
export const FETCH_HOUSE_INFORMATION = 'FETCH_HOUSE_INFORMATION'
export const FETCH_HOUSE_REVIEWS = 'FETCH_HOUSE_REVIEWS'
export const FETCH_HOUSE_PRICE_SUGGESTION = 'FETCH_HOUSE_PRICE_SUGGESTION'
export const FETCH_HOST_MESSAGES = 'FETCH_HOST_MESSAGES'
export const FETCH_HOUSES = 'FETCH_HOUSES'
export const FETCH_USER_INFORMATION = 'FETCH_USER_INFORMATION'
export const CHANGE_HOST_PASSWORD = 'CHANGE_HOST_PASSWORD'
export const FETCH_TRANSACTIONS = 'FETCH_TRANSACTIONS'
export const FETCH_TRANSACTIONS_DETAILS = 'FETCH_TRANSACTIONS_DETAILS'
export const CHANGE_SETTLEMENT = 'CHANGE_SETTLEMENT'
export const GET_SETTLEMENT = 'GET_SETTLEMENT'
export const UPDATE_SETTLEMENT = 'UPDATE_SETTLEMENT'
export const FETCH_HOUSE_PRICING_LIST = 'FETCH_HOUSE_PRICING_LIST'
export const SET_HOUSES = 'SET_HOUSES'
export const SET_PRICING = 'SET_PRICING'
export const SET_STEP = 'SET_STEP'
export const RESET_ACTIVATION = 'RESET_ACTIVATION'

// trips
export const FECTH_TRIPS_LIST = 'FECTH_TRIPS_LIST'

// Career
export const FETCH_CAREER = 'FETCH_CAREER'
export const FETCH_POSITION_DETAILS = 'FETCH_POSITION_DETAILS'
// houseRegister
export const FETCH_HOUSES_LIST = 'FETCH_HOUSES_LIST'
export const FETCH_CITIES = 'FETCH_CITIES'
export const SET_HOUSE_TYPE = 'SET_HOUSE_TYPE'
export const SET_HOUSE_DATA = 'SET_HOUSE_DATA'
export const GET_DEFAULT_VALUES = 'GET_DEFAULT_VALUES'
export const GET_CONTRACT_FILE = 'GET_CONTRACT_FILE'
export const GET_HOST_CANCELLATION_RULES = 'GET_HOST_CANCELLATION_RULES'

//cancellation reserve status
export const CHANGE_CANCELLATION_RESERVE_STATUS =
  'CHANGE_CANCELLATION_RESERVE_STATUS'
export const CANCELLATION_RESERVE_AFTER_PAYMENT =
  'CANCELLATION_RESERVE_AFTER_PAYMENT'
export const SET_CANCELLING_REASON = 'SET_CANCELLING_REASON'

//white label
export const FETCH_WHITE_LABEL_INVOICE_DATA = 'FETCH_WHITE_LABEL_INVOICE_DATA'

// hotel
export const FETCH_HOTEL_SEARCHED_CITIES = 'FETCH_HOTEL_SEARCHED_CITIES'
export const SET_HOTEL_SEARCH = 'SET_HOTEL_SEARCH'
export const FETCH_HOTEL_AVAILABILITY = 'FETCH_HOTEL_AVAILABILITY'
export const FETCH_HOTEL_DETAILS = 'FETCH_HOTEL_DETAILS'
export const FETCH_HOTEL_PAGE = 'FETCH_HOTEL_PAGE'
export const FETCH_HOTEL_ROOMS = 'FETCH_HOTEL_ROOMS'
export const FETCH_HOTEL_TRIPS = 'FETCH_HOTEL_TRIPS'

// flight
export const FETCH_FLIGHT_CITIES = 'FETCH_FLIGHT_CITIES'
export const FETCH_FLIGHT_SEARCHED_CITIES = 'FETCH_FLIGHT_SEARCHED_CITIES'
export const SET_FLIGHT_SEARCH = 'SET_FLIGHT_SEARCH'
export const SET_FLIGHT_SEARCH_RESULTS = 'SET_FLIGHT_SEARCH_RESULTS'
export const FETCH_FLIGHT_SEARCH = 'FETCH_FLIGHT_SEARCH'
export const SET_SELECTED_FLIGHT_OFFER = 'SET_SELECTED_FLIGHT_OFFER'
export const SET_FLIGHT_BOOKING_FORM = 'SET_FLIGHT_BOOKING_FORM'
export const BOOK_FLIGHT = 'BOOK_FLIGHT'
export const FETCH_FLIGHT_TRIPS = 'FETCH_FLIGHT_TRIPS'
